module.exports = __webpack_public_path__ + "static/media/snata.e0300198.jpg";